export const ALERT_THEME = {
    errorAlert: '#FF5252',
    warningAlert: '#FFBF00'
}

export const DEFAULT_THEME = {
    accent: '#35424B',
    black: '#2D2926',
    dark: '#555',
    error: '#B31412',
    info: '#4b9bd4',
    light: '#F2F2F2',
    primary: '#ce0f69',
    secondary: '#003473',
    success: '#4aa04f',
    warning: '#FDC91D',
    white: '#ffffff'
}

export default {
    ...ALERT_THEME,
    ...DEFAULT_THEME
}
